type Callback = (data: any) => void;

const getEvents = () => {
  const storage: any = typeof window !== 'undefined' ? window : global;

  if (!storage.__ShopComponentsEvents) {
    storage.__ShopComponentsEvents = {};
  }

  return storage.__ShopComponentsEvents;
};

export const on = (eventName: string, fn: Callback) => {
  const _events = getEvents();

  if (!_events[eventName]) {
    _events[eventName] = [];
  }
  _events[eventName].push(fn);
};

export const off = (eventName: string, fn?: Callback) => {
  const _events = getEvents();

  if (!fn) {
    delete _events[eventName];
    return;
  }

  const index = _events[eventName].indexOf(fn);

  if (index > -1) {
    _events[eventName].splice(index, 1);

    if (!_events[eventName].length) {
      off(eventName);
    }
  }
};

export const emit = <TData>(eventName: string, data: TData) => {
  const _events = getEvents();
  const fns = _events[eventName];

  if (fns) {
    fns.forEach((fn: (data: TData) => void) => fn(data));
  }
};

export const get = () => getEvents();

export default {
  on,
  off,
  emit,
  get,
};
